export const environment = {
  BASE_URL: 'https://api.dev.blackkonnect.io/services',
  keycloakUrl: 'https://sandbox.blackkonnect.io/auth',
  mambaApiUrl: 'https://sandbox.mamba.blackkonnect.io',
  controlTowerApiUrl: 'https://control-tower-sandbox-rqh28.ondigitalocean.app',
  ussdApiUrl: '/ussd-sim-api',
  ussdApplicationsApiUrl: '/ussd-apps-api',
  keyCloak: {
    clientSecret: '1hSCLe3yqvorg29RqtlZ2pIjLzUZbRRm',
    grantType: 'password',
    clientId: 'blackkonnect-cxp-webportal',
    realmName: 'blackkonnect',
    // scopes: ['openid', 'profile', 'email', 'roles','organisations'],
    scopes: ['openid', 'profile', 'email'],
  },
  metabase: {
    instanceUrl: 'https://ussdanalytics.blackkonnect.io',
    secretKey: 'bc5e06ddc37c215b3abd1807c99fd70bdb6d61eb9f80380ff48a863e80bf2cfa',
    dashboardId: 6,
    smsDashboardId: 6,
    ussdDashboardId: 2,
    ussdPublicAnalyticsUrl: 'https://ussdanalytics.blackkonnect.io',
    ussdPublicDashboardUuid: '5235be3c-680e-48c6-bb47-f5dcc0efce3a',
  },
  metabaseMessaging: {
    instanceUrl: 'https://blackkonnect-bespoke-metabase-4o7tz.ondigitalocean.app',
    secretKey: '9880187b40f04ef667894c34043c5680a6b6d792a1faf75b7e8433d18ec63282',
    dashboardId: 3,
  },
  // PayPoint bill-payment dashboards (prepaid electricity / airtime / Pay TV)
  metabasePayPoint: {
    instanceUrl: 'https://dashboard.campaigns.blackkonnect.io',
    secretKey: '51aed821fb6c885c76e418d28f8b6a4daae396571354bb889d4e92602db57c28',
    dashboardId: 111,
  },
  // Deprecated: use environment.metabase.secretKey instead
  metabaseSecretKey: '51aed821fb6c885c76e418d28f8b6a4daae396571354bb889d4e92602db57c28'
};

